import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import {cryptoJs} from '@deanwu/vue-component-library'
import dictList from './dict.js'

const dictData = {};
for (let key in dictList) {
	dictData[key] = stateSerialize(dictList[key]);
}
function stateSerialize(data) {
	let json = {};
	data.forEach(item => {
		if (typeof item.value == 'object') {
			item.value.forEach(i => {
				json[i] = item;
			});
		} else {
			json[item.value] = item;
		}
	});
	
	return json;
}

Vue.use(Vuex);

const app = new Vue();
const Store = new Vuex.Store({
	state: {
		...dictList,
		dictData: {
			...dictData
		},
		asyncDictList: {},
		asyncDictData: {},
		session: '',
		saasInfo: null,
		userInfo: null,
		authList: [],
		navList: [],
		formulaDict: null,
		customField: null,
		systemConfig: null,
		publicConfig: null
	},

	getters: {
		initialized(state) {
			return state.systemConfig && state.formulaDict && state.customField;
		},

		customFieldMenu(state) {
			let nav = state.navList.find(item => item.menu_unique_key == 'g_organization');
			let field = nav.child_menu_list.find(item => item.menu_unique_key == 'p_custom');
			let menu = field ? field.child_menu_list.find(item => item.menu_unique_key == 'm_custom_field') : undefined;
			return menu ? menu.child_menu_list : [];
		},

		allAuthKey(state) {
			return state.authList.map(item => item.key);
		},

		freeAuthKey(state) {
			return state.authList.filter(item => !item.vip).map(item => item.key);
		},

		/**当前商户是否有接驳作业：门店版没有接驳与调拨，接驳类待办、作业入口都不摆出来；
		  能力开关由登录信息下发（版本判定只在服务端 EditionCapabilityService 一处），端内不拿版本编码判等；
		  登录信息未到位时按有接驳处理，与服务端保守兜底口径一致（PC 端 saasInfo 不落本地缓存，每次进系统重新拉）*/
		hasHandover(state) {
			let capability = state.saasInfo && state.saasInfo.edition_capability;
			return !capability || capability.has_handover !== false;
		}
	},

	mutations: {
		updateAsyncDict(state, data) {
			Vue.set(state.asyncDictList, data.dict, data.data);
			Vue.set(state.asyncDictData, data.dict, stateSerialize(data.data));
		},
		
		setSystemConfig(state, data) {
			if (state.session) {
				state.systemConfig = data;
			}
			if (data) {
				state.publicConfig = data;
			}
		},

		setFormulaDict(state, data) {
			state.formulaDict = data;
		},

		setCustomField(state, data) {
			state.customField = data;
		},
		
		setSession(state, data) {
			state.session = data;
			if (!data) {
				state.systemConfig = null;
			}
		},
		
		// 设置企业信息
		setSaasInfo(state, data) {
			state.saasInfo = data;
		},
		
		// 设置用户信息
		setUserInfo(state, data) {
			delete data.session;
			state.userInfo = data;
		},
		
		// 设置权限列表
		setAuth(state, data) {
			state.authList = data;
		},
		
		// 设置导航菜单
		setNav(state, data) {
			data.unshift({
				id: 1,
				menu_name: '工作台',
				menu_unique_key: 'home'
			});
			data.forEach(menu => {
				while (menu.child_menu_list && menu.child_menu_list.find(item => item.child_menu_list && item.child_menu_list.length)) {
					let index = menu.child_menu_list.findIndex(item => item.child_menu_list && item.child_menu_list.length);
					let target = menu.child_menu_list.find(item => item.child_menu_list && item.child_menu_list.length);
					target.child_menu_list.forEach(item => item.is_child = true);
					menu.child_menu_list.splice.apply(menu.child_menu_list, [index + 1, 0].concat(target.child_menu_list));
					target.is_parent = true;
					target.child_menu_list = null;
				}
			});
			state.navList = data;
		}
	},

	actions: {
		updateSystemConfig(store) {
			app.request({
				url: '/sys/config',
				success: data => {
					store.commit('setSystemConfig', data);
				}
			})
		},

		updateFieldConfig(store, callback) {
			Promise.all([
				app.request({
					url: '/sys_field/map'
				}),

				app.request({
					url: '/sys_field/custom/map'
				})
			]).then(([{data: dict}, {data: custom}]) => {
				store.commit('setFormulaDict', dict);
				store.commit('setCustomField', custom);
				callback && callback();
			});
		},

		updateLoginInfo(store) {
			app.request({
				url: '/sys_user/get_login_info',
				success: data => {
					store.dispatch('setLoginInfo', data);
				},
				fail: (code, data, msg) => {
					if (code == 9200) {
						app.$confirm({
							message: msg,
							buttonName: '我知道了',
							cancelButton: false,
							resolve: () => {
								store.commit('setSession', '');
								$app.navigateTo('/login');
							}
						})
						return false;
					}
				}
			})
		},

		setLoginInfo(store, data) {
			store.commit('setSession', data.user_info.session);
			store.commit('setSaasInfo', data.saas_info);
			store.commit('setUserInfo', data.user_info);
			store.commit('setAuth', data.user_menu_key_list.map(item => {
				return {
					key: item.menu_unique_key,
					vip: item.is_vip == 1
				}
			}));
			store.commit('setNav', data.user_menu_list || []);
		},
		
		getAsyncDict(store, dict) {
			store.commit('updateAsyncDict', {
				dict: dict,
				data: []
			});
			
			app.request({
				url: '/dic/info/options',
				data: {
					dic_type_code: dict
				},
				success: data => {
					store.commit('updateAsyncDict', {
						dict,
						data
					});
				}
			})
		}
	},

	plugins: [createPersistedState({
		key: 'session',
		paths: ['session', 'authList'],
		storage: {
			getItem(key) {
				try {
					return JSON.parse(cryptoJs.AES.decrypt(localStorage.getItem(key), 'session').toString(cryptoJs.enc.Utf8));
				} catch(e) {
					return undefined;
				}
			},
			
			setItem(key, val) {
				localStorage.setItem(key, cryptoJs.AES.encrypt(JSON.stringify(val), 'session').toString());
			},
			
			removeItem(key) {
				localStorage.removeItem(key);
			}
		}
	})]
});
export default Store

const asyncMapState = function(data) {
	const res = {};
	data.forEach(dict => {
		res[dict] = {
			get() {
				if (!Store.state.asyncDictList[dict]) {
					Store.dispatch('getAsyncDict', dict);
				}
				
				return Store.state.asyncDictList[dict];
			},
			set() {}
		}
	});
	return res;
}
export {
	asyncMapState
}
